import React from "react";

//content and images
import homecontent from "../homecontent.js";
import movement from './cardImages/movementcard.webp'
import recovery from './cardImages/recoverycard.webp'
import performance from './cardImages/performancecard.webp'

//components
import Card from "./Card.jsx";

const MainContent = () => {
  return (
    <div
      className="process-container"
      data-aos="fade-up"
      data-aos-duration="800"
      data-aos-easing="ease-in-out"
    >
      <h2>
        <span className="blue-color">MOVEMENT</span> IS{" "}
        <span className="blue-color">MEDICINE</span>
      </h2>
      <span className="hr-line"></span>
      <p className="process-subtitle">
        Dr. Wade and the team at Concierge Wellness will elevate your well-being
      </p>
      <p>Movement | Recovery | Performance</p>
      <div className="process-info-container">
        <Card
          image={movement}
          alt="Someone stretching their hamstrings"
          title="Photo by Vitaly Gariev"
          heading="Movement"
          duration="1200"
          bulletpoints={homecontent.home.bulletpointsOne}
          tagline={`Restore comfortable, confident movement through personalized care designed to improve mobility, reduce discomfort, and help you move through life with ease.`}
        />
        <Card
          image={recovery}
          alt="a patient recieving dry needle treatment in back"
          heading="Recovery"
          duration="800"
          bulletpoints={homecontent.home.bulletpointsTwo}
          tagline={`Whether you're overcoming an injury or seeking post-operative care, 
    our expert guidance will help you regain strength and flexibility, ensuring a swift and effective recovery.`}
        />
        <Card
          image={performance}
          alt="A man squats to pick up a barbell"
          heading="Performance"
          duration="1000"
          bulletpoints={homecontent.home.bulletpointsThree}
          tagline={` Tailored to your unique goals, our programs enhance endurance, optimize movement mechanics, and empower you to achieve peak performance.`}
        />
      </div>
    </div>
  );
};

export default MainContent;
